// done-loading-constant.ts
var DONE_LOADING_CONSTANT = "a-print:done-loading";
export {
  DONE_LOADING_CONSTANT
};
